/* Heartcrafted owner-approved design masters, October 2026.
   These are lossless crops from the owner's exact approved PNG sheets.
   Never substitute generated vectors, assume editable type, or redraw the ornamentation. */
(function(global){
'use strict';
const templates=Object.freeze([
  {"id":"HC-WH01","name":"Ever After Flourish","family":"Heartcrafted Wedding Heirlooms","group":"keepsake_box","url":"https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-WH01.png?v=1792009020","status":"approved_raster_reference"},
  {"id":"HC-WH02","name":"Wedding Title Stack","family":"Heartcrafted Wedding Heirlooms","group":"keepsake_box","url":"https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-WH02.png?v=1792009026","status":"approved_raster_reference"},
  {"id":"HC-WH03","name":"Signature Memories","family":"Heartcrafted Wedding Heirlooms","group":"keepsake_box","url":"https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-WH03.png?v=1792009034","status":"approved_raster_reference"},
  {"id":"HC-FF01","name":"Botanical Wreath","family":"Heartcrafted Floral Frames","group":"keepsake_box","url":"https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-FF01.png?v=1792009040","status":"approved_raster_reference"},
  {"id":"HC-FF02","name":"Garden Crest","family":"Heartcrafted Floral Frames","group":"keepsake_box","url":"https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-FF02.png?v=1792009047","status":"approved_raster_reference"},
  {"id":"HC-FF03","name":"Corner Bloom Frame","family":"Heartcrafted Floral Frames","group":"keepsake_box","url":"https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-FF03.png?v=1792009054","status":"approved_raster_reference"},
  {"id":"HC-FF04","name":"Ornate Family Plaque","family":"Heartcrafted Floral Frames","group":"keepsake_box","url":"https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-FF04.png?v=1792009067","status":"approved_raster_reference"},
  {"id":"HC-MG01","name":"Split Initial Monogram","family":"Heartcrafted Monograms","group":"keepsake_box","url":"https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-MG01.png?v=1792009074","status":"approved_raster_reference"},
  {"id":"HC-MG02","name":"Laurel Monogram","family":"Heartcrafted Monograms","group":"keepsake_box","url":"https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-MG02.png?v=1792009079","status":"approved_raster_reference"},
  {"id":"HC-MG03","name":"Established Crest","family":"Heartcrafted Monograms","group":"keepsake_box","url":"https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-MG03.png?v=1792009086","status":"approved_raster_reference"},
  {"id":"HC-SG01","name":"Romantic Signature","family":"Heartcrafted Signature Styles","group":"keepsake_box","url":"https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-SG01.png?v=1792009092","status":"approved_raster_reference"},
  {"id":"HC-SG02","name":"Minimal Luxe Lines","family":"Heartcrafted Signature Styles","group":"keepsake_box","url":"https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-SG02.png?v=1792009099","status":"approved_raster_reference"},
  {
    "id": "HC-JR01",
    "name": "Evermore Garden",
    "family": "Heartcrafted Journals",
    "group": "journal",
    "url": "https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-JR01.png?v=1792002573",
    "status": "approved_raster_reference"
  },
  {
    "id": "HC-JR02",
    "name": "Storybook Crest",
    "family": "Heartcrafted Journals",
    "group": "journal",
    "url": "https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-JR02.png?v=1792002578",
    "status": "approved_raster_reference"
  },
  {
    "id": "HC-JR03",
    "name": "Written in Love",
    "family": "Heartcrafted Journals",
    "group": "journal",
    "url": "https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-JR03.png?v=1792002587",
    "status": "approved_raster_reference"
  },
  {
    "id": "HC-JR04",
    "name": "Botanical Monogram",
    "family": "Heartcrafted Journals",
    "group": "journal",
    "url": "https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-JR04.png?v=1792002594",
    "status": "approved_raster_reference"
  },
  {
    "id": "HC-JR05",
    "name": "Heirloom Title Page",
    "family": "Heartcrafted Journals",
    "group": "journal",
    "url": "https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-JR05.png?v=1792002602",
    "status": "approved_raster_reference"
  },
  {
    "id": "HC-JR06",
    "name": "Keepsake Signature",
    "family": "Heartcrafted Journals",
    "group": "journal",
    "url": "https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-JR06.png?v=1792002609",
    "status": "approved_raster_reference"
  },
  {
    "id": "HC-JB01",
    "name": "Garden Keepsake Crest",
    "family": "Heartcrafted Jewelry Boxes",
    "group": "jewelry_box",
    "url": "https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-JB01.png?v=1792002620",
    "status": "approved_raster_reference"
  },
  {
    "id": "HC-JB02",
    "name": "Laurel Promise",
    "family": "Heartcrafted Jewelry Boxes",
    "group": "jewelry_box",
    "url": "https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-JB02.png?v=1792002627",
    "status": "approved_raster_reference"
  },
  {
    "id": "HC-JB03",
    "name": "Timeless Family Plaque",
    "family": "Heartcrafted Jewelry Boxes",
    "group": "jewelry_box",
    "url": "https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-JB03.png?v=1792002716",
    "status": "approved_raster_reference"
  },
  {
    "id": "HC-JB04",
    "name": "Romantic Bloom Monogram",
    "family": "Heartcrafted Jewelry Boxes",
    "group": "jewelry_box",
    "url": "https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-JB04.png?v=1792002690",
    "status": "approved_raster_reference"
  },
  {
    "id": "HC-JB05",
    "name": "Cherished Signature",
    "family": "Heartcrafted Jewelry Boxes",
    "group": "jewelry_box",
    "url": "https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-JB05.png?v=1792002696",
    "status": "approved_raster_reference"
  },
  {
    "id": "HC-JB06",
    "name": "Forever Heirloom Frame",
    "family": "Heartcrafted Jewelry Boxes",
    "group": "jewelry_box",
    "url": "https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-JB06.png?v=1792002705",
    "status": "approved_raster_reference"
  },
  {
    "id": "HC-CB01",
    "name": "Gathered With Love",
    "family": "Heartcrafted Cutting Boards",
    "group": "cutting_board",
    "url": "https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-CB01.png?v=1792002728",
    "status": "approved_raster_reference"
  },
  {
    "id": "HC-CB02",
    "name": "Family Table Wreath",
    "family": "Heartcrafted Cutting Boards",
    "group": "cutting_board",
    "url": "https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-CB02.png?v=1792002734",
    "status": "approved_raster_reference"
  },
  {
    "id": "HC-CB03",
    "name": "Kitchen Heirloom Crest",
    "family": "Heartcrafted Cutting Boards",
    "group": "cutting_board",
    "url": "https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-CB03.png?v=1792002742",
    "status": "approved_raster_reference"
  },
  {
    "id": "HC-CB04",
    "name": "The Williams Kitchen",
    "family": "Heartcrafted Cutting Boards",
    "group": "cutting_board",
    "url": "https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-CB04.png?v=1792002748",
    "status": "approved_raster_reference"
  },
  {
    "id": "HC-CB05",
    "name": "Homegrown Monogram",
    "family": "Heartcrafted Cutting Boards",
    "group": "cutting_board",
    "url": "https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-CB05.png?v=1792002756",
    "status": "approved_raster_reference"
  },
  {
    "id": "HC-CB06",
    "name": "From Our Kitchen",
    "family": "Heartcrafted Cutting Boards",
    "group": "cutting_board",
    "url": "https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-CB06.png?v=1792002764",
    "status": "approved_raster_reference"
  },
  {
    "id": "HC-JW01",
    "name": "Petite Crest Initials",
    "family": "Heartcrafted Jewelry",
    "group": "jewelry",
    "url": "https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-JW01.png?v=1792002776",
    "status": "approved_raster_reference"
  },
  {
    "id": "HC-JW02",
    "name": "Laurel Date Monogram",
    "family": "Heartcrafted Jewelry",
    "group": "jewelry",
    "url": "https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-JW02.png?v=1792002782",
    "status": "approved_raster_reference"
  },
  {
    "id": "HC-JW03",
    "name": "Forever Yours",
    "family": "Heartcrafted Jewelry",
    "group": "jewelry",
    "url": "https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-JW03.png?v=1792002789",
    "status": "approved_raster_reference"
  },
  {
    "id": "HC-JW04",
    "name": "Blooming Initial Pair",
    "family": "Heartcrafted Jewelry",
    "group": "jewelry",
    "url": "https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-JW04.png?v=1792002796",
    "status": "approved_raster_reference"
  },
  {
    "id": "HC-JW05",
    "name": "Tiny Heirloom Script",
    "family": "Heartcrafted Jewelry",
    "group": "jewelry",
    "url": "https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-JW05.png?v=1792002801",
    "status": "approved_raster_reference"
  },
  {
    "id": "HC-JW06",
    "name": "Signature Charm Layout",
    "family": "Heartcrafted Jewelry",
    "group": "jewelry",
    "url": "https://cdn.shopify.com/s/files/1/0691/4749/2509/files/Heartcrafted-Approved-HC-JW06.png?v=1792002809",
    "status": "approved_raster_reference"
  }
]);
const ids=Object.freeze(templates.map(item=>item.id));
const byId=new Map(templates.map(item=>[item.id,item]));
// Each design's editable areas are mapped individually so the approved florals
// and ornamental lines stay in the original unmodified raster image.
// Positions use percentages of the approved crop; final engraving proof is still required.
const EDIT_AREAS = {
 "HC-JR01": [["name",22,38,57,22,"script"]],
 "HC-JR02": [["initials",37,20,26,17,"serif"],["date",40,44,20,5,"small"],["name",19,74,62,8,"caps"]],
 "HC-JR03": [["name",22,67,56,6,"caps"],["date",32,74,36,5,"small"]],
 "HC-JR04": [["firstInitial",37,15,26,56,"serif"],["name",20,76,60,10,"caps"]],
 "HC-JR05": [["name",26,54,48,7,"caps"],["date",28,64,44,6,"small"]],
 "HC-JR06": [["name",10,34,81,23,"script"]],
 "HC-JB01": [["firstInitial",38,36,9,15,"serif"],["secondInitial",53,36,11,15,"serif"],["date",28,88,44,6,"small"]],
 "HC-JB02": [["initials",34,32,34,20,"serif"],["date",31,62,38,7,"small"]],
 "HC-JB03": [["name",20,42,62,13,"caps"],["date",30,65,40,7,"small"]],
 "HC-JB04": [["firstInitial",35,29,12,21,"serif"],["secondInitial",55,29,14,21,"serif"],["date",33,91,34,6,"small"]],
 "HC-JB05": [["name",6,34,88,30,"script"],["date",31,73,38,7,"small"]],
 "HC-JB06": [["name",20,40,61,10,"caps"],["date",31,59,40,9,"small"]],
 "HC-CB01": [["name",26,77,48,10,"caps"],["date",41,86,18,7,"small"]],
 "HC-CB02": [["name",19,35,62,20,"caps"]],
 "HC-CB03": [["firstInitial",44,20,15,26,"serif"],["name",16,74,70,14,"caps"],["year",85,44,11,7,"small"]],
 "HC-CB04": [["name",8,37,84,30,"caps"]],
 "HC-CB05": [["firstInitial",33,21,13,29,"serif"],["secondInitial",54,21,16,29,"serif"],["name",25,67,50,9,"caps"],["year",48,84,12,5,"small"]],
 "HC-CB06": [["name",17,43,66,23,"script"]],
 "HC-JW01": [["initials",37,40,26,21,"serif"]],
 "HC-JW02": [["initials",32,31,36,22,"serif"],["date",30,60,40,10,"small"]],
 "HC-JW03": [["name",15,25,70,42,"script"]],
 "HC-JW04": [["firstInitial",27,47,14,32,"serif"],["secondInitial",59,47,16,32,"serif"]],
 "HC-JW05": [["name",9,42,82,20,"script"],["date",36,64,28,10,"small"]],
 "HC-JW06": [["firstInitial",40,14,19,25,"serif"],["secondInitial",41,51,17,26,"serif"],["date",36,82,28,9,"small"]],
 "HC-WH01": [["name",8,40,84,17,"caps"],["date",26,61,48,9,"small"]],
 "HC-WH02": [["firstName",14,21,72,18,"caps"],["joiner",40,41,20,14,"script"],["secondName",14,57,72,19,"caps"],["date",24,85,52,9,"small"]],
 "HC-WH03": [["name",5,20,90,30,"script"],["date",24,86,52,8,"small"]],
 "HC-FF01": [["initials",34,27,32,20,"serif"],["name",29,49,42,8,"caps"],["date",30,65,40,8,"small"]],
 "HC-FF02": [["firstInitial",43,16,14,16,"serif"],["secondInitial",43,38,14,16,"serif"],["name",17,75,66,8,"caps"],["date",28,88,44,7,"small"]],
 "HC-FF03": [["initials",26,31,50,26,"serif"],["name",19,63,62,8,"caps"],["date",33,81,34,7,"small"]],
 "HC-FF04": [["name",20,48,60,16,"caps"],["date",28,74,44,8,"small"]],
 "HC-MG01": [["firstInitial",36,7,16,22,"serif"],["secondInitial",53,36,16,28,"serif"],["name",21,71,58,9,"caps"],["date",27,87,46,7,"small"]],
 "HC-MG02": [["initials",31,24,40,34,"script"],["name",14,81,72,8,"caps"],["date",27,92,46,6,"small"]],
 "HC-MG03": [["firstInitial",44,13,12,13,"serif"],["secondInitial",43,30,14,14,"serif"],["name",9,61,82,12,"caps"],["date",27,91,46,7,"small"]],
 "HC-SG01": [["name",5,35,90,27,"script"],["date",28,85,44,9,"small"]],
 "HC-SG02": [["firstInitial",31,4,38,39,"serif"],["name",18,56,64,12,"caps"],["date",37,46,26,6,"small"]]
};
const CLEAR_AREAS = {
 "HC-WH01": [[8,41,84,14],[26,61,48,8]],
 "HC-WH02": [[20,22,60,16],[42,41,16,13],[16,58,68,19],[24,86,52,8]],
 "HC-WH03": [[4,20,92,33],[25,52,51,11],[24,78,52,7],[24,86,52,8]],
 "HC-FF01": [[35,28,34,18],[30,49,42,7],[31,65,38,7]],
 "HC-FF02": [[44,16,12,16],[44,38,12,14],[17,75,66,8],[28,87,44,7]],
 "HC-FF03": [[26,31,51,27],[19,63,62,7],[32,80,37,7]],
 "HC-FF04": [[19,49,62,14],[29,74,43,8]],
 "HC-MG01": [[36,7,17,22],[52,36,18,28],[21,71,58,8],[27,87,46,7]],
 "HC-MG02": [[32,18,38,48],[18,81,64,8],[27,91,46,7]],
 "HC-MG03": [[44,13,12,13],[43,30,14,14],[9,61,82,11],[22,73,56,8],[27,91,46,7]],
 "HC-SG01": [[4,31.5,92,42.5],[28,85,44,8]],
 "HC-SG02": [[31,4,38,39],[37,46,26,6],[18,56,64,12],[20,74,60,22]],
 "HC-JR01": [[22,38,57,22]],
 "HC-JR02": [[37,20,26,17],[40,44,20,5],[19,74,62,8]],
 "HC-JR03": [[22,67,56,5],[32,74,36,5]],
 "HC-JR05": [[26,54,48,7],[28,64,44,6]],
 "HC-JR06": [[10,33,82,25]],
 "HC-CB03": [[43.5,20,16.5,26],[16,74,71,14],[85,44,11,7]],
 "HC-CB05": [[33,21,13,29],[54,21,16,29],[25,67,50,9],[48,84,12,5]],
 "HC-JB01": [[38,37,9,14],[53,37,11,14],[28,88,44,6]],
 "HC-JB02": [[34,33,34,18],[31,62,38,7]],
 "HC-JB03": [[20,42,63,12],[30,65,40,7]],
 "HC-JB04": [[35,30,12,20],[55,30,14,20],[33,91,34,6]],
 "HC-JB05": [[4,32,93,35],[31,73,38,6]],
 "HC-JB06": [[19,40,63,10],[31,60,40,6]],
 "HC-JW04": [[27,47,14,33],[59,47,16,33]],
 "HC-JW06": [[40,14,19,25],[41,51,17,26],[36,82,29,9]]
};
const ARTWORK_SIZES = {
 "HC-JR03": [462,351],
 "HC-FF03": [362,247],
 "HC-WH02": [362,230],
 "HC-JB04": [469,324],
 "HC-CB05": [454,278],
 "HC-CB01": [474,295],
 "HC-JB05": [456,324],
 "HC-JB02": [456,321],
 "HC-JR06": [462,350],
 "HC-FF02": [369,247],
 "HC-MG01": [362,247],
 "HC-JR01": [463,351],
 "HC-JR05": [456,350],
 "HC-FF01": [362,230],
 "HC-CB03": [470,295],
 "HC-WH03": [359,230],
 "HC-WH01": [369,230],
 "HC-JW03": [457,300],
 "HC-CB04": [474,278],
 "HC-JR04": [463,350],
 "HC-JW02": [450,300],
 "HC-JW06": [457,278],
 "HC-SG01": [359,239],
 "HC-SG02": [362,239],
 "HC-JW05": [450,278],
 "HC-MG02": [369,239],
 "HC-CB06": [470,278],
 "HC-CB02": [454,295],
 "HC-JW01": [456,300],
 "HC-JR02": [456,351],
 "HC-JB01": [469,321],
 "HC-MG03": [362,239],
 "HC-JB06": [472,324],
 "HC-FF04": [359,247],
 "HC-JW04": [456,278],
 "HC-JB03": [472,321]
};
function personalizationParts(value){
 const lines=String(value||'').replace(/\r\n?/g,'\n').split('\n').map(x=>x.trim()).filter(Boolean).slice(0,4);
 const name=lines[0]||'';
 const second=lines[1]||'';
 const datePattern=/\b\d{4}\b|\b\d{1,2}[/.:-]\d{1,2}\b|\b(?:january|february|march|april|may|june|july|august|september|october|november|december|jan|feb|mar|apr|jun|jul|aug|sep|sept|oct|nov|dec)\b/i;
 const date=lines.slice(1).find(x=>datePattern.test(x))||(lines.length===1&&datePattern.test(lines[0])?lines[0]:'');
 const names=name.split(/\s*(?:&|\+|\band\b|\/)\s*/i).filter(Boolean);
 const firsts=names.length>1?names.map(x=>x.match(/[A-Za-z]/)?.[0]?.toUpperCase()||'').filter(Boolean):[];
 const tokens=name.match(/[A-Za-z]+/g)||[];
 const initials=firsts.length>1?firsts.slice(0,2):tokens.length>1?[tokens[0][0].toUpperCase(),tokens[1][0].toUpperCase()]:name.match(/[A-Za-z]/)?[name.match(/[A-Za-z]/)[0].toUpperCase()]:[];
 return {name,firstName:names[0]||name,secondName:names[1]||'',joiner:names.length>1?'&':'',date,year:date.match(/\b\d{4}\b/)?.[0]||'',firstInitial:initials[0]||'',secondInitial:initials[1]||'',initials:initials.join(' & ')||name.slice(0,2).toUpperCase()};
}
function personalizeArtwork(target,design,options){
 const sourceWords=String(options?.words||'').trim();
 if(!sourceWords)return null;
 const fields=EDIT_AREAS[design.id];
 if(!fields?.length)return null;
 const parts=personalizationParts(sourceWords);
 const overlay=target.querySelector?.('svg[data-personalization-overlay]')||document.createElementNS('http://www.w3.org/2000/svg','svg');
 overlay.replaceChildren();
 const [artWidth,artHeight]=ARTWORK_SIZES[design.id];
 const yUnit=10*artHeight/artWidth;
 overlay.setAttribute('viewBox','0 0 1000 '+(yUnit*100));
 overlay.setAttribute('preserveAspectRatio','none');
 overlay.setAttribute('aria-hidden','true');
 overlay.style.position='absolute';overlay.style.inset='0';
 overlay.style.width='100%';overlay.style.height='100%';
 overlay.style.pointerEvents='none';
 overlay.style.background='transparent';
 overlay.style.zIndex='1';
 const background='#fff';
 const add=(tag,attrs,content)=>{
  const n=document.createElementNS('http://www.w3.org/2000/svg',tag);
  for(const [k,v] of Object.entries(attrs))n.setAttribute(k,String(v));
  if(content!==undefined)n.textContent=content;
  overlay.appendChild(n);return n;
 };
 const clear=CLEAR_AREAS[design.id]||fields.map(([,x,y,w,h])=>[x,y,w,h]);
 clear.forEach(([x,y,w,h])=>add('rect',{x:x*10,y:y*yUnit,width:w*10,height:h*yUnit,fill:background,'data-clear-sample':'true'}));
 fields.forEach(([role,x,y,w,h,type])=>{
  let phrase=String(parts[role]||'').slice(0,96);
  // Remove all old sample wording, including old sample dates, when personalizing.
  // If the customer has not supplied a date, leave that field clean rather than
  // presenting the sample date as if it belonged to their order.
  if(!phrase)return;
  if(type==='caps')phrase=phrase.toUpperCase();
  const serif='"Baskerville","Times New Roman",Georgia,serif';
  const script='"Snell Roundhand","Segoe Script","Brush Script MT",cursive';
  const handwriting='"Bradley Hand","Segoe Print",cursive';
  const family=options?.font==='Script'?script:options?.font==='Handwriting'?handwriting:options?.font==='Serif'?serif:type==='script'?script:serif;
  const maxFont=h*yUnit*.8;
  const targetWidth=w*9.2;
  const estimated=phrase.length*(type==='script'?.49:.60);
  const size=Math.max(12,Math.min(maxFont,targetWidth/Math.max(estimated,1)));
  const align=['left','right'].includes(options.align)?options.align:'center';
  const anchor=align==='left'?'start':align==='right'?'end':'middle';
  const position=align==='left'?x+w*.04:align==='right'?x+w*.96:x+w/2;
  const text=add('text',{x:position*10,y:(y+h*.53)*yUnit,fill:'#21140c','text-anchor':anchor,'font-family':family,'font-size':size.toFixed(2),'font-weight':options.bold?'700':type==='caps'?'500':'400','font-style':options.italic||type==='script'&&options.font!=='Serif'?'italic':'normal','letter-spacing':type==='caps'?'3':'1'},phrase);
  text.setAttribute('dominant-baseline','central');
  text.setAttribute('data-fit-width',String(targetWidth));
 });
 return overlay;
}

function render(target,id,options={}){
 const design=byId.get(id);
 if(!target||!design)return false;
 // Keep the SAME image element while text changes, so each keystroke never
 // discards its in-flight download (particularly important in iPhone WebViews).
 let wrap=target.firstElementChild,image=wrap?.querySelector?.('img');
 const reusable=wrap?.dataset?.approvedDesignId===id&&!!image;
 if(!reusable){
  wrap=document.createElement('div');
  wrap.className='hcs-approved-image-composite';
  wrap.dataset.approvedDesignId=id;
  wrap.style.position='relative';wrap.style.width='100%';wrap.style.lineHeight='0';
  image=document.createElement('img');
  image.dataset.approvedArtworkId=design.id;
  image.loading=options.mode==='thumbnail'?'lazy':'eager';
  image.decoding='async';
  [image.width,image.height]=ARTWORK_SIZES[design.id];
  image.style.display='block';image.style.width='100%';
  image.style.height='auto';image.style.objectFit='contain';
  image.addEventListener?.('load',()=>{if(image.naturalWidth>0)wrap.classList?.add?.('hcs-image-ready')});
  image.addEventListener?.('error',()=>{
   wrap.classList?.add?.('hcs-image-error');
   if(!wrap.querySelector?.('.hcs-image-load-warning')){
    const fallback=document.createElement('p');fallback.className='hcs-image-load-warning';
    fallback.textContent='We could not load this design image right now. Please try another design or reload the studio.';
    wrap.append(fallback);
   }
  });
  wrap.append(image);
  target.replaceChildren(wrap);
  image.src=design.url;
 }
 const personalized=!!String(options.words||'').trim()&&options.mode!=='reference';
 image.style.filter=personalized?'grayscale(1) contrast(20)':'none';
 image.alt=design.name+' — approved Heartcrafted artwork'+(personalized?', personalized concept preview':' with sample lettering');
 if(image.complete&&image.naturalWidth>0)wrap.classList?.add?.('hcs-image-ready');
 // Original artwork is never changed. Customer personalization remains a
 // separate reversible overlay, hidden until the approved reference loads.
 if(personalized){
  const overlay=personalizeArtwork(wrap,design,options);
  if(overlay){
   overlay.setAttribute('data-personalization-overlay','true');
   if(!wrap.querySelector?.('svg[data-personalization-overlay]'))wrap.append(overlay);
   overlay.querySelectorAll?.('text[data-fit-width]').forEach(node=>{
    const measured=node.getComputedTextLength?.()||0,limit=Number(node.getAttribute('data-fit-width'));
    if(measured>limit)node.setAttribute('font-size',(Number(node.getAttribute('font-size'))*limit/measured).toFixed(2));
   });
  }
 }else wrap.querySelector?.('svg[data-personalization-overlay]')?.remove?.();
 return true;
}
function groupForProduct(product){
 const name=String((product?.title||'')+' '+(product?.type||'')).toLowerCase();
 if(/jewelry box|jewellery box|ring box|trinket box/.test(name))return 'jewelry_box';
 if(/journal|notebook|diary/.test(name))return 'journal';
 if(/cutting board|chopping board|charcuterie board|paddle board/.test(name))return 'cutting_board';
 if(/necklace|pendant|bracelet|bangle|charm|earrings|jewelry(?! box)|jewellery(?! box)/.test(name))return 'jewelry';
 if(/keepsake|memory box|memorial box|wooden box|valet box|treasure box|heirloom box/.test(name))return 'keepsake_box';
 return null;
}
global.HeartcraftedApprovedDesignLibrary=Object.freeze({approved:true,referenceOnly:true,templates,ids,render,groupForProduct});
})(window);

